module.exports = __webpack_public_path__ + "static/media/davos.5bea9809.jpg";